<template>
  <dialog-base
    :key="renderKey"
    v-bind="$props"
    :header="$t('auth.dialogs.incorrectPortalDialog.headers.carrierSignIn')"
    @close="close"
    max-width="100%"
    :value="showDialog"
    width="650px">
    <template #body>
      <v-container class="px-0">
        <div>{{ email }}</div>
        <div class="mt-4 text-black">
          {{
            $t(
              'auth.dialogs.incorrectPortalDialog.messages.itSeemsLikeThisEmailIsRegisteredAsACarrierToSignInPleaseProceedToTheOpendockSchedulingPortal'
            )
          }}
        </div>
      </v-container>
    </template>
    <template #dialog-actions>
      <action-group @cancel="close" :hide-confirm="true">
        <template v-slot:additional-actions-after>
          <primary-button
            :href="`${lunaUrl}/login`"
            target="_blank"
            rel="noopener"
            class="primary-button v-btn v-size--default px-4 font-weight-bold text-black">
            {{ $t('auth.forms.loginForm.links.goToSchedulingPortal') }}
            <v-icon class="text-black ml-2" size="small">mdi-arrow-right</v-icon>
          </primary-button>
        </template>
      </action-group>
    </template>
  </dialog-base>
</template>

<script>
import dialogMixin from '@satellite/components/mixins/dialogMixin';
import config from '@/config/config';

/**
 * Incorrect Portal Dialog
 * @displayName Incorrect Portal Dialog
 */
export default {
  mixins: [dialogMixin],
  computed: {
    lunaUrl() {
      return config.luna_url;
    }
  },
  props: {
    /**
     * Alert message to display in dialog
     */
    alertMessage: {
      type: String,
      required: false
    },
    /**
     * Alert type
     * @values success | error
     */
    alertType: {
      type: String,
      required: false,
      default: 'success'
    },
    email: {
      type: String,
      required: true
    }
  }
};
</script>
